import PhoneFrame from "./PhoneFrame";
import logoHeader from "../../assets/images/logo-header.png";
import skylineLight from "../../assets/images/splash-skyline-light.png";

export default function FormLayout({ children, footer }) {
  return (
    <PhoneFrame className="bg-scabPageBg" scroll={false}>
      <div className="h-full flex flex-col relative">
        <img
          src={skylineLight}
          alt=""
          className="absolute inset-0 w-full h-full object-cover object-bottom pointer-events-none opacity-80"
        />
        <header className="relative z-10 w-full bg-scabWhite flex flex-col items-center pt-3 pb-3 shrink-0 shadow-sm">
          <img
            src={logoHeader}
            alt="اسکب"
            className="w-[48px] h-[48px] object-contain"
          />
          <div className="text-medium font-IRANSansBold mt-1">ثبت نام اولیه</div>
        </header>
        <div className="relative z-10 flex-1 overflow-y-auto overflow-x-hidden phone-scroll px-4 py-4">
          {children}
        </div>
        {footer ? (
          <div className="relative z-10 shrink-0 px-4 pb-5 pt-2 bg-gradient-to-t from-scabPageBg via-scabPageBg to-transparent">
            {footer}
          </div>
        ) : null}
      </div>
    </PhoneFrame>
  );
}
